export default String.raw`
<g id="Newsletter rozbudowany/szary/desktop">
    <rect width="1440" height="288" class="newsletterBgColor"/>
    <g id="Frame 249">
        <g id="Frame 261" class="newsletterFont">
            <g id="Frame 257">
                <g id="Interface/Mailbox" transform="translate(130, 60)">
                    <use href="#mailbox" width="52" height="52"></use>
                </g>
                <g id="Frame 246">
                    <foreignObject x="214" y="48" width="488" height="80">
                        <div xmlns="http://www.w3.org/1999/xhtml" class="newsletterFont">
                            <h3 style="margin: 0 0 8px 0; font-size: 18px; font-weight: 600; line-height: 1.3;">
                                TRANSLATION_Prv_JoinNewsletter_A
                            </h3>
                            <p style="margin: 0; font-size: 14px; line-height: 1.5;">
                                TRANSLATION_Prv_JoinNewsletter_B_PartA TRANSLATION_Prv_JoinNewsletter_B_PartB
                            </p>
                        </div>
                    </foreignObject>
                </g>
            </g>
            <g id="Frame 253">
                <g id="Frame 254">
                    <g id="Korzysci newsletter">
                        <g id="Interface/Newspaper" transform="translate(130, 151)">
                            <use href="#newspaper" width="32" height="32"></use>
                        </g>
                        <text xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="178" y="173.091">TRANSLATION_Prv_NewMagazines</tspan></text>
                    </g>
                    <g id="Korzysci newsletter_2">
                        <g id="Interface/Percent" transform="translate(433, 151)">
                            <use href="#percent" width="32" height="32"></use>
                        </g>
                        <text xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="479" y="173.091">TRANSLATION_Prv_UniqueOffers</tspan></text>
                    </g>
                </g>
                <g id="Frame 255">
                    <g id="Korzysci newsletter_3">
                        <g id="Interface/delivery" transform="translate(130, 208)">
                            <use href="#truck" width="32" height="32"></use>
                        </g>
                        <text xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="178" y="229.091">TRANSLATION_Prv_DeliverySchedule</tspan></text>
                    </g>
                    <g id="Korzysci newsletter_4">
                        <g id="Interface/idea" transform="translate(433, 208)">
                            <use href="#lightbulb-on" width="32" height="32"></use>
                        </g>
                        <text xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="479" y="229.091">TRANSLATION_Prv_InspirationsAndTips</tspan></text>
                    </g>
                </g>
            </g>
        </g>
        <g id="Frame 262">
            <g id="Frame 251">
                <g id="Frame 247">
                    <g id="1. Text Input Basic">
                        <g id="Input">
                            <rect x="732.5" y="64.5" width="577" height="39" rx="4.5" class="inputsBgColor bgColorFont--stroke"/>
                            <g id="Interface/Mail" transform="translate(748, 72)" class="bgColorFont">
                                <use href="#envelope" width="24" height="24"></use>
                            </g>
                            <text class="newsletterFont" id="Input text" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="780" y="89.0909">TRANSLATION_Prv_NewsletterInputPlaceholder</tspan></text>
                        </g>
                    </g>
                </g>
                <g id="Frame 679">
                    <g id="Frame 263">
                        <g id="Checkbox" class="inputsBgColor bgColorFont--stroke">
                            <rect id="Base" x="736.5" y="132.5" width="15" height="15" rx="3.5"/>
                        </g>
                        <foreignObject x="760" y="120" width="350" height="50">
                            <div xmlns="http://www.w3.org/1999/xhtml" class="newsletterFont" style="font-size: 12px; line-height: 1.4; display: flex; align-items: center; height: 100%;">
                                <p style="margin: 0;">
                                    TRANSLATION_Prv_IAgree_PartA TRANSLATION_Prv_IAgree_PartB
                                </p>
                            </div>
                        </foreignObject>
                    </g>
                    <g id="Primary button">
                        <rect x="1125" y="120" width="185" height="40" rx="5" class="btnSolidBgColor"/>
                        <foreignObject x="1125" y="120" width="185" height="40">
                            <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: center; justify-content: center; height: 100%; width: 100%;">
                                <span class="btnSolidTextColor" style="font-size: 14px; font-weight: 600; text-align: center;">TRANSLATION_Prv_SaveMe</span>
                            </div>
                        </foreignObject>
                    </g>
                </g>
            </g>
            <g id="disclaimer-section">
                <foreignObject x="732" y="170" width="578" height="80">
                    <div class="newsletterFont" style="font-size: 11px; line-height: 1.5;">
                        <p style="margin: 0;">
                            TRANSLATION_Prv_SingingIn_PartA TRANSLATION_Prv_SingingIn_PartB <a href="#" class="iconColors" style="text-decoration: underline;">TRANSLATION_Prv_SingingIn_PartC</a> TRANSLATION_Prv_SingingIn_PartD TRANSLATION_Prv_SingingIn_PartE
                        </p>
                    </div>
                </foreignObject>
            </g>
        </g>
    </g>
</g>

`;